var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEventSuggestions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEnventSuggestions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final",
    transform: "translate(-705.000000, -460.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "translate(670.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-Suggestions",
    transform: "translate(26.000000, 278.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15058592,6.33063492 L0.10996092,3.10236775 C-0.000195320001,2.98533443 -0.03066408,2.81352798 0.03222656,2.66516757 C0.0955078,2.51700419 0.24003908,2.4208556 0.39980468,2.4208556 L5.03464881,2.4208556 L3.43457032,0.807017544 L2.40019532,0.807017544 C2.17910156,0.807017544 2.00019532,0.626344918 2.00019532,0.403508772 C2.00019532,0.180672626 2.17910156,5.81756865e-14 2.40019532,5.81756865e-14 L3.60019532,5.81756865e-14 C3.70644532,5.81756865e-14 3.80800784,0.042557586 3.88300784,0.118215481 L6.16599659,2.4208556 L15.6001953,2.4208556 C15.759961,2.4208556 15.9044922,2.51700419 15.9677734,2.66516757 C16.0306641,2.81333095 16.0001953,2.98533443 15.8900391,3.10236775 L12.8498047,6.33063496 C12.8473511,6.33324481 12.8448664,6.33581771 12.8423515,6.33835332 L8.40019532,11.0559709 L8.40019532,16.607687 L12.4685547,17.318171 C12.6603516,17.3516653 12.8001954,17.5195313 12.8001954,17.715769 L12.8001954,18.9649123 C12.8001953,19.1877484 12.6212891,19.3684211 12.4001953,19.3684211 L3.60019532,19.3684211 C3.37910156,19.3684211 3.20019532,19.1877484 3.20019532,18.9649123 L3.20019532,17.754386 C3.20019532,17.5593305 3.33847656,17.3922526 3.52871096,17.3573791 L7.60019532,16.6106156 L7.60019532,11.0553584 L3.15059439,6.33064391 Z M3.61230468,5.64912281 L12.3880859,5.64912281 L14.6685547,3.22787314 L1.33144532,3.22787314 L3.61230468,5.64912281 Z",
    id: "icEnventSuggestions"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEventSuggestions);
export default __webpack_public_path__ + "static/media/icEventSuggestions.4f9b2743608eee9050046b4ca3648cb7.svg";
export { ForwardRef as ReactComponent };